module.exports = __webpack_public_path__ + "static/img/图层6.284840e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层6.png
// module id = T/Rj
// module chunks = 0